import React, { useLayoutEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import queryString from 'query-string';
import config from 'config';
import { useAuth0, useApiHealthCheck } from 'utils';
import { usePolicy } from 'utils/usePolicy';

import MaintenancePage from './MaintenancePage';
import Footer from './Footer';
import { AppBar } from '../alf-design';
import Background from './Background';

const Layout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth0();
  const { error, loading, selectedPolicy, policies } = usePolicy({
    loadPolicies: true,
  });

  const isAdmin = user
    ? user?.email?.includes('@slideinsurance.com') && user?.role?.isAdmin
    : false;
  const isDashboardFallback =
    !isAdmin &&
    !loading &&
    selectedPolicy === null &&
    (!Array.isArray(policies) || policies.length === 0);
  const isPageNotFound = location.pathname === '/page-not-found';
  const wrapperBgClass =
    isPageNotFound || isDashboardFallback
      ? 'bg-legacy-white'
      : 'bg-legacy-dashboardBg';

  const isOnline =
    config.healthCheck === 'true'
      ? useApiHealthCheck(selectedPolicy?.policySystem)
      : true;

  useLayoutEffect(() => {
    document.title = 'Online Policy Access for Slide Insurance Policyholders';
    const { code, state, ...params } = queryString.parse(location.search);

    if (code || state) {
      navigate(`${location.pathname}?${queryString.stringify(params)}`, {
        replace: true,
      });
    }
  }, [location]);

  const policySearch = selectedPolicy?.policyNumber
    ? `?policy=${encodeURIComponent(selectedPolicy.policyNumber)}`
    : '';

  const handleHelp = () => {
    navigate(`/help${policySearch}`);
  };
  const handleUserProfile = () => {
    navigate(`/user-profile${policySearch}`);
  };
  const handleDashboard = () => {
    if (selectedPolicy) {
      navigate(`/?policy=${selectedPolicy?.policyNumber}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  if (
    (!loading && config.maintenancePage === 'true') ||
    (selectedPolicy && isOnline === false) ||
    (!selectedPolicy && error?.err?.status === 503)
  ) {
    return <MaintenancePage />;
  }

  return (
    <div className="h-full relative">
      <Background>
        <div className={`${wrapperBgClass} flex flex-col flex-1`}>
          <AppBar
            onHelp={handleHelp}
            onUserProfile={handleUserProfile}
            onHome={handleDashboard}
          />
          <main
            id="main-content"
            role="main"
            className="flex flex-auto flex-col justify-center lg:mx-[132.5px]"
          >
            <div className="w-full self-center p-[24px]">
              <Outlet />
            </div>
          </main>
          <Footer maxWidth />
        </div>
      </Background>
    </div>
  );
};

export default Layout;
